import { memberAdas$ } from '../services/subjects';
import { AdasMember } from 'types/AdasMember';
import { Connectable, filter, firstValueFrom } from 'rxjs';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

export const useAdasMember = () => {
    const {
        data: member,
        isLoading: loadingMember,
        error: memberErrorMessage,
        refetch: reloadMember,
    } = useQuery<AdasMember | null>({
        queryKey: ['adasMember'],
        retry: false,
        queryFn: async () => {
            const res = await firstValueFrom(memberAdas$.pipe(filter(Boolean)));
            return res;
        },
        enabled: true,
        refetchOnWindowFocus: false,
    });

    useEffect(() => {
        const connection = (memberAdas$ as Connectable<AdasMember>).connect();
        return () => connection.unsubscribe();
    }, []);

    return {
        member,
        loadingMember,
        memberErrorMessage,
        reloadMember,
    };
};
